<template>
  <div class = "votingUsersList">
    <el-card>
      <el-button type="primary" slot="header" @click="back">{{$t('lang.btn_returnNeighborView')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight132"
      >
        <el-table-column type="selection" width="55" v-if="votingUsersListcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
        <el-table-column 
          prop="nickName" 
          :label="$t('lang.lab_nickName')">
        </el-table-column>
        <el-table-column 
          prop="userName" 
          :label="$t('lang.lab_userName')">
        </el-table-column>
        <el-table-column 
          prop="redBlue" 
          :label="$t('lang.lab_redBlue')">
          <template slot-scope="scope">
            <span v-if="scope.row.redBlue === 1">{{$t('lang.lab_red')}}</span>
            <span v-if="scope.row.redBlue === 2">{{$t('lang.lab_blue')}}</span>
          </template>
        </el-table-column>
        <el-table-column 
          prop="info" 
          :label="$t('lang.lab_info')"
          width="600px">
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.info&&scope.row.info.length> require('@/config/enum').tableDatamaxlength40"
              :disabled="false"
            >
              <div slot="content">
                <span >
                  {{ scope.row.info }}
                </span>
              </div>
              <div>
                {{ scope.row.info.substring(0, require('@/config/enum').tableDatamaxlength40) | valueIsNull }}
                <span
                  v-if="scope.row.info.length>require('@/config/enum').tableDatamaxlength40"
                >...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.info | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:votingUsersList
 *@Description:参加投票用户
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-04
 */
export default {
  data() {
    return {
      multipleSelection: [], // 多选框
      id: '', // id
      pageCount: 1, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      tableData: [], // 列表数据
      votingUsersListcheckbox: require('@/config/enum').votingUsersListcheckbox // 是否隐藏复选框
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getData()
  },
  methods: {
    // 参加投票用户列表查询
    getData() {
      let loading = this.$loading()
      this.$get(`/courtsupport/?pageNo=${this.pageNo}&pageSize=${this.pageSize}&courtroomId=${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 返回
    back() {
      this.$router.push({ name: 'neighborView' })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getData()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getData()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  }
}
</script>

<style lang="scss">
.el-tooltip__popper.is-light {
  max-width: 300px;
}
</style>